
import { useState, useEffect } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import { VacationResults } from "@/components/VacationResults";
import { VacationMascot } from "@/components/VacationMascot";
import { useSearchManager } from "@/components/SearchManager";
import { useIsMobile } from "@/hooks/use-mobile";

const ResultatenPage = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const query = searchParams.get('q') || '';
  const [searchResults, setSearchResults] = useState<any[] | null>(null);
  const [loading, setLoading] = useState(true);
  const { handleSearch } = useSearchManager();
  const isMobile = useIsMobile();

  useEffect(() => {
    if (!query) {
      navigate('/');
      return;
    }

    const performSearch = async () => {
      setLoading(true);
      try {
        await handleSearch(
          query,
          setSearchResults,
          () => {}, // setCurrentQuery - not needed here
          () => {}, // setCurrentView - not needed here
          setLoading
        );
      } catch (error) {
        console.error('Search error:', error);
        setLoading(false);
      }
    };

    performSearch();
  }, [query, handleSearch, navigate]);

  const handleBack = () => {
    navigate('/');
  };

  const handleNewSearch = (newQuery: string) => {
    navigate(`/resultaten?q=${encodeURIComponent(newQuery)}`);
  };

  if (loading) {
    return (
      <div className="max-w-4xl mx-auto text-center space-y-8 py-16">
        <div className="flex items-center justify-center gap-6 mb-8">
          <div>
            <div className="flex items-center justify-center gap-4 mb-6">
              <VacationMascot size={isMobile ? "small" : "large"} />
              <div className="flex flex-col items-center">
                <div className="animate-spin rounded-full h-12 w-12 border-4 border-orange-600 border-t-transparent mb-4"></div>
                <div className="flex space-x-1">
                  <div className="w-2 h-2 bg-orange-500 rounded-full animate-bounce"></div>
                  <div className="w-2 h-2 bg-amber-500 rounded-full animate-bounce" style={{ animationDelay: '0.1s' }}></div>
                  <div className="w-2 h-2 bg-yellow-500 rounded-full animate-bounce" style={{ animationDelay: '0.2s' }}></div>
                </div>
              </div>
            </div>
            <h2 className="text-3xl md:text-5xl font-bold bg-gradient-to-r from-orange-600 via-orange-500 to-amber-500 bg-clip-text text-transparent mb-4 font-poppins">
              Zonnie zoekt nu jouw volgende vakantie!
            </h2>
            <p className="text-xl text-gray-600 mb-2">
              Even geduld terwijl ik de beste matches voor je zoek...
            </p>
            <p className="text-lg text-orange-600 font-medium">
              Zoeken naar: "{query}"
            </p>
          </div>
        </div>
        
        <div className="bg-orange-50 rounded-lg p-6 border border-orange-200 max-w-md mx-auto">
          <p className="text-orange-700 text-sm">
            💡 Tip: Zonnie doorzoekt duizenden vakanties om de perfecte match voor jou te vinden!
          </p>
        </div>
      </div>
    );
  }

  if (!searchResults) {
    return (
      <div className="max-w-4xl mx-auto text-center py-16">
        <h2 className="text-2xl font-bold text-gray-800 mb-4">
          Er ging iets mis bij het zoeken
        </h2>
        <button 
          onClick={handleBack}
          className="bg-orange-500 hover:bg-orange-600 text-white px-6 py-2 rounded-lg"
        >
          Terug naar home
        </button>
      </div>
    );
  }

  return (
    <VacationResults 
      vacations={searchResults}
      searchQuery={query}
      onBack={handleBack}
      onSearch={handleNewSearch}
      loading={false}
    />
  );
};

export default ResultatenPage;
